import { all } from 'redux-saga/effects';

import auth from './auth/sagas';
// import user from './user/sagas';
// import car from './car/sagas';
// import company from './company/sagas';
// import forgotPassword from './forgotPassword/sagas';
// import resetPassword from './resetPassword/sagas';
// import fipe from './fipe/sagas';
// import dashboard from './dashboard/sagas';
// import paymentMethod from './paymentMethod/sagas';
// import sale from './sale/sagas';

export default function* rootSaga() {
  return yield all([
    auth,
  ]);
}